import React, { useState } from 'react';
import { ArrowCounterClockwise } from '@phosphor-icons/react';
import { resubmitPi, piErrorMessage } from '../lib/piActions';

// Shown wherever a REJECTED PI surfaces: reason + "Revise & Resubmit".
export const PiRejectedNotice = ({ pi, onResubmitted, compact = false, testid = 'pi-rejected-notice' }) => {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  if (!pi || pi.status !== 'rejected') return null;

  const go = async () => {
    setBusy(true);
    setError('');
    try {
      const updated = await resubmitPi(pi.id);
      onResubmitted?.(updated);
    } catch (e) {
      setError(piErrorMessage(e, 'Could not resubmit PI'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className={`rounded-lg border border-rose-200 bg-rose-50 text-rose-800 ${compact ? 'px-2 py-1.5 text-[11px]' : 'px-3 py-2 text-xs'}`} data-testid={testid}>
      <div className="flex items-center justify-between gap-3">
        <div className="min-w-0">
          <span className="font-semibold">PI {pi.pi_number} rejected — revise &amp; resubmit.</span>
          {pi.approver_decision_reason && (
            <span className="block mt-0.5 text-rose-700/90 break-words" data-testid={`${testid}-reason`}>
              Reason{pi.approver_name ? ` (${pi.approver_name})` : ''}: {pi.approver_decision_reason}
            </span>
          )}
        </div>
        <button
          type="button"
          onClick={go}
          disabled={busy}
          className="shrink-0 inline-flex items-center gap-1 px-3 py-1 rounded-full font-semibold bg-rose-600 text-white hover:bg-rose-700 disabled:opacity-60 transition-colors"
          data-testid={`${testid}-resubmit`}
        >
          <ArrowCounterClockwise size={12} weight="bold" /> {busy ? 'Resubmitting…' : 'Revise & Resubmit'}
        </button>
      </div>
      {error && <div className="mt-1 font-medium text-rose-900" data-testid={`${testid}-error`}>{error}</div>}
    </div>
  );
};
